import { useState } from "react";

export default function PasswordGate({ onAuthenticate, title = "Dashboard", description = "Enter password to view statistics." }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await fetch("/api/auth-stats.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });

      if (response.ok) {
        onAuthenticate(password);
      } else {
        const data = await response.json().catch(() => null);
        setError(data?.error || `Server error (${response.status})`);
      }
    } catch {
      setError("Connection error. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white dark:bg-surface-card-dark p-8">
          <h1 className="text-xl font-bold text-slate-900 dark:text-white mb-1">
            {title}
          </h1>
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
            {description}
          </p>
          <form onSubmit={handleSubmit}>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoFocus
              className="w-full px-4 py-2.5 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-white placeholder-slate-400 focus:ring-2 focus:ring-primary-400/50 focus:border-primary-400 outline-none transition-colors mb-3"
            />
            {error && (
              <p className="text-red-500 text-sm mb-3">{error}</p>
            )}
            <button
              type="submit"
              disabled={loading || !password}
              className="w-full px-4 py-2.5 bg-primary-400 hover:bg-primary-500 disabled:opacity-50 text-white rounded-lg font-medium transition-colors"
            >
              {loading ? "Checking..." : "View Stats"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
